module.exports = __webpack_public_path__ + "img/Asset3.e5cd6a36.png";